import index from './text-media-tabs';
export default index;
